export enum FleetLeaseEndQueryKeys {
  GetVehicleListVR = 'getVehicleListVR'
}
